import script from "./ApixDriveSourceTabInstruction.vue?vue&type=script&setup=true&lang=js"
export * from "./ApixDriveSourceTabInstruction.vue?vue&type=script&setup=true&lang=js"

import "./ApixDriveSourceTabInstruction.vue?vue&type=style&index=0&id=74a2466a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74a2466a"]])

export default __exports__